import { atom } from "recoil";

export const walletPromotionEditModalStore = atom({
	key: "walletPromotionEditModalStore",
	default: {
		show: false,
		loaded: true,
		id: 0,
		currentOption: {
			placementType: [
				{ value: "deposit_crypto", label: "Deposit crypto" },
				{ value: "deposit_fiat", label: "Deposit fiat" },
				{ value: "withdrawal_crypto", label: "Withdrawal crypto" },
				{ value: "withdrawal_fiat", label: "Withdrawal fiat" },
			],
			badgeType: [
				{ value: "from", label: "From" },
				{ value: "to", label: "To" },
				{ value: "none", label: "No text" },
			],
			badgeAction: [
				{ value: "live_chat", label: "Live chat" },
				{ value: "link", label: "Link" },
				{ value: "none", label: "None" },
			],
			linkTranslationType: [
				{ value: "local", label: "Local" },
				{ value: "mixed", label: "Mixed" },
				{ value: "international", label: "International" },
			],
			active: [
				{ value: "1", label: "Enabled" },
				{ value: "0", label: "Disabled" },
			],
		},
		linkTranslationType: "",
		link: "",
		textLink: "",
		placement: [],
		badgePercent: "",
		badgeType: { value: "none", label: "No text" },
		badgeAction: { value: "none", label: "None" },
		priority: "",
		startDate: null,
		endDate: null,
		active: { value: "1", label: "Enabled" },
		cohortConditions: "",
		conditions: [],
	},
});
